



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ApiService } from '../../services/api.service';
import { ConfigurationService } from '../../services/configuration.service';


@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')],
    animations: [fadeInOut]
})
export class HomeComponent {
    inboundFilesRecent: any = [];
    constructor(public configurations: ConfigurationService, private apiService: ApiService) {
        this.apiService.getInboundFilesRecent().subscribe(r => {
            this.inboundFilesRecent = r;
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/home/home.component.ts